/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Internal/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Compose from './Compose/index'
import Participants from './Participants/index'
import React from 'react'
import Tools from './Tools/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Internal({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/MessageTools/Internal"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="Internal.Vertical"
  data-view-path={viewPath}
 style={{'--ml-1-JQOLD': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--mr-2-JQOLD': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pb-3-JQOLD': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-4-JQOLD': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pl-5-JQOLD': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-6-JQOLD': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical}`}
>
<Participants
  viewPath={`${viewPath}/Participants`}
/>
<Compose
  viewPath={`${viewPath}/Compose`}
/>
<Tools
  viewPath={`${viewPath}/Tools`}
/>
</div>
{children}
</React.Fragment>)
}